export function getGoogleAuthErrorMessage(error, fallback = 'Google sign-in failed. Please try again.') {
  const code = String(error?.code || '');
  const currentHost = typeof window !== 'undefined' ? window.location.hostname : '';

  if (code === 'auth/popup-closed-by-user') return '';
  if (code === 'auth/popup-blocked') {
    return 'The Google sign-in popup was blocked. Allow popups and try again.';
  }
  if (code === 'auth/cancelled-popup-request') {
    return 'Another Google sign-in window is already open.';
  }
  if (code === 'auth/unauthorized-domain') {
    return currentHost
      ? `Google sign-in is not authorized for this site yet (${currentHost}). Add this domain in Firebase Console -> Authentication -> Settings -> Authorized domains, then try again.`
      : 'Google sign-in is not authorized for this site yet. Add your site domain in Firebase Console -> Authentication -> Settings -> Authorized domains, then try again.';
  }
  if (code === 'auth/operation-not-allowed') {
    return 'Google sign-in is not enabled for this app right now.';
  }
  if (code === 'auth/account-exists-with-different-credential') {
    return 'An account already exists with this email using a different sign-in method.';
  }

  return fallback;
}
